export default "__VITE_ASSET__CVv3sHB1__"